import React from 'react';
import { Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import IconExclamationMark from '@/assets/icon-exclamation-mark.svg?react';
import TrashIcon from '@/comp/common/icons/TrashIcon';

import { DeleteItemPopconfirmIconContainer, PopconfirmDeleteItemGlobalStyle } from '../styled';

const DeleteItemPopconfirmIcon = ({
  itemName,
  onConfirm,
  className,
}: {
  itemName: string;
  onConfirm: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <DeleteItemPopconfirmIconContainer>
      <PopconfirmDeleteItemGlobalStyle />
      <Popconfirm
        placement="topRight"
        title={<span className="delete-item-popconfirm-title">{t('deletePopconfirmTitle', { item: itemName })}</span>}
        onConfirm={onConfirm}
        okText={t('Yes')}
        cancelText={t('Cancel')}
        icon={<IconExclamationMark />}
        overlayStyle={{ width: 360, zIndex: 1202 }}
      >
        <TrashIcon className={cn('delete-item-icon', className)} />
      </Popconfirm>
    </DeleteItemPopconfirmIconContainer>
  );
};

export default DeleteItemPopconfirmIcon;
